export default "__VITE_ASSET__DMlLQFO7__"